export default __webpack_public_path__ + "static/media/cryptoverse.a0367226.PNG";